import { WSEmptyState } from "@wingspanhq/fe-component-library";

export const EmptyStateNoMatch = () => {
  return (
    <WSEmptyState
      orientation="horizontal"
      type="search"
      title="No policies match this requirement"
      description="There are currently no policies in your “My resources” section that match this requirement. Review your options below and take action. "
    />
  );
};
